import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconHorn({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path id="a" d="M0 .133h16.006v12.95H0z" />
				<path id="c" d="M.098.1H3.05v2.513H.098z" />
			</defs>
			<g fill="none" fillRule="evenodd">
				<path
					fill="#E42822"
					fillRule="nonzero"
					d="M9.598 8.773a.325.325 0 0 0-.33.32c0 .178.147.321.33.321 3.954 0 7.423 3.051 7.423 6.53 0 .344-.027.69-.081 1.029a.322.322 0 0 0 .326.37c.16 0 .3-.113.325-.272.06-.37.09-.75.09-1.128 0-3.887-3.702-7.17-8.083-7.17m2.177 4.547L7.4 16.14a.316.316 0 0 0-.093.445.333.333 0 0 0 .457.09l4.375-2.82a.315.315 0 0 0 .093-.444.336.336 0 0 0-.457-.09M6.595 3a.325.325 0 0 0-.33.32v2.2c0 .176.148.32.33.32s.33-.144.33-.32v-2.2a.325.325 0 0 0-.33-.32M8.51 5.79a.334.334 0 0 0 .455-.098l.867-1.319a.315.315 0 0 0-.1-.443.335.335 0 0 0-.456.098L8.41 5.346a.316.316 0 0 0 .1.443M3.96 4.028a.335.335 0 0 0-.456-.098.316.316 0 0 0-.1.443l.868 1.319a.334.334 0 0 0 .455.097.315.315 0 0 0 .1-.442l-.867-1.32z"
				/>
				<path
					fill="#FEFEFE"
					fillRule="nonzero"
					d="M5.03 7.805c0 .18-.152.327-.337.327a.33.33 0 0 1-.336-.327c0-.181.15-.328.336-.328.185 0 .336.147.336.328m1.951-.001c0 .181-.15.328-.336.328a.33.33 0 0 1-.336-.328c0-.18.15-.327.336-.327s.336.147.336.327m1.951.001c0 .18-.15.327-.336.327a.33.33 0 0 1-.336-.327c0-.181.15-.328.336-.328s.336.147.336.328"
				/>
				<g transform="translate(3 6.074)">
					<mask id="b" fill="#fff">
						<use xlinkHref="#a" />
					</mask>
					<path
						fill="#FEFEFE"
						fillRule="nonzero"
						d="M.665.775h5.761q.03.98.228 1.924H.786A12.6 12.6 0 0 1 .665.775m6.138 2.557c1.112 4.123 4.53 7.476 8.81 8.298a.33.33 0 0 0 .387-.253.32.32 0 0 0-.26-.376C10.82 10.056 7.106 5.549 7.08.505c.003-.017.01-.033.01-.05a.326.326 0 0 0-.33-.322H.342a.325.325 0 0 0-.33.321c0 .023.009.042.013.064C.022.533.014.546.013.563c-.015.215-.324 5.322 3.196 8.983 2.257 2.347 5.562 3.537 9.824 3.537.811 0 1.695-.02 2.426-.057a.324.324 0 0 0 .312-.337.33.33 0 0 0-.346-.304c-.72.036-1.592.057-2.392.057-4.07 0-7.21-1.12-9.338-3.33-1.743-1.81-2.49-4.046-2.806-5.771h5.87c.016 0 .03-.007.044-.009"
						mask="url(#b)"
					/>
				</g>
				<g transform="translate(18.13 16.662)">
					<mask id="d" fill="#fff">
						<use xlinkHref="#c" />
					</mask>
					<path
						fill="#E42822"
						fillRule="nonzero"
						d="m.868.864 1.505.526-.015.203-1.57.302.08-1.03zm2.171.245q-.005-.03-.015-.057-.014-.029-.03-.053-.017-.026-.038-.05Q2.935.93 2.909.913A.3.3 0 0 0 2.85.88Q2.842.873 2.833.87L.683.119C.667.114.652.115.638.112.624.11.61.102.596.1Q.583.102.574.103.542.104.51.11a.4.4 0 0 0-.07.017l-.034.02a.3.3 0 0 0-.07.05L.314.226A.3.3 0 0 0 .27.297L.26.312q-.003.02-.004.04-.01.021-.014.044L.1 2.268c-.002.015.004.028.005.043 0 .014-.003.028 0 .043q.003.011.008.022.008.023.019.046a.31.31 0 0 0 .24.181c.012.002.02.008.032.009h.025q.03 0 .063-.006l2.241-.431c.01-.002.017-.008.026-.01a.3.3 0 0 0 .066-.027.3.3 0 0 0 .046-.029.3.3 0 0 0 .047-.046q.019-.02.033-.043a.3.3 0 0 0 .025-.059.3.3 0 0 0 .016-.056q.003-.01.006-.021l.053-.69q-.001-.01-.003-.02a.3.3 0 0 0-.008-.065z"
						mask="url(#d)"
					/>
				</g>
			</g>
		</svg>
	);
}
